import { gql } from '@apollo/client';
export const getAvailabilityPeriods = gql`
  query availabilityPeriodsFranchise($input: AvailabilityPeriodSearchInput) {
    availabilityPeriodsFranchise(input: $input) {
     franchiseId
     franchise{
      id
      name
      settings{
        canManageAvailability

      }
     }
     periods { 
      id
      startDate
      endDate
      startTime
      endTime
      dayOfWeek
      resourceId
      dateTimes {
        id
        date
        startTime
        endTime
      }
      periodFranchises {
        id 
        name
        settings{
        canManageAvailability
      }
      }
     }
    }
  }
`;
